import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import PollListTable from '../Util/PollListTable';


export default class PollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loading1: true,
            pollList: [],
            pollActiveList: []

        };
    }
    componentDidMount() {
        localStorage.removeItem('courseId');
        localStorage.removeItem('spId');
        localStorage.removeItem('poll');
        localStorage.removeItem('organizationalUnitEmployeeId');
        localStorage.removeItem('courseImplementationGroupId');
        localStorage.removeItem('courseName');
        localStorage.removeItem('numberOfStudentsWhoRatedEmployee');
        localStorage.removeItem('numberOfStudentsWhoRatedCourse');
        axios.get('questionnaire/all/3/')
            .then(res => {
                const pollList = res.data;
                this.setState({ pollList, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });

        axios.get('questionnaire/all/2/')
            .then(res => {
                const pollActiveList = res.data;
                this.setState({ pollActiveList, loading1: false });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.pollList;
    }

    render() {
        return (

            <div>
                <Header as="h1"> Ankete </Header>
                {/*<Segment.Group clearing raised >*/}
                {/*    <Segment> <Header as="h3"> Aktivne ankete </Header></Segment>*/}

                {/*    <Segment>*/}
                {/*        { this.state.loading1 ?*/}
                {/*            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>*/}
                {/*                <Loader active inline="centered" />*/}
                {/*            </div> :*/}
                {/*            <PollListTable*/}
                {/*                polls={this.state.pollActiveList}*/}
                {/*                active*/}

                {/*            />}*/}
                {/*    </Segment>*/}

                {/*</Segment.Group>*/}
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> Završene ankete </Header></Segment>

                    <Segment>
                        { this.state.loading ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                                <Loader active inline="centered" />
                            </div> :
                            <PollListTable
                                polls={this.state.pollList}
                                rowRedirect="/ankete/osoblje"
                                firstButtonLink="/ankete/osoblje"
                                firstAltButtonLink="/ankete/sp"
                                firstAltButtonText="Studijski programi"
                                firstButtonText="Akademsko osoblje"
                            />}
                    </Segment>

                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/QAPoll/PollList.js